
export enum LIBRARY_STATE {
	ACTIVE = "active",
	ARCHIVED = "archived"
}

